import {ValueObject} from '@s-ui/domain'

import {UserConsentUserValueObject} from './UserConsentUserValueObject.js'

export class UserConsentsStatusUserValueObject extends ValueObject {
  #consents

  /**
   * @param {Array.<UserConsentsStatusUserValueObject>} consents
   * */
  static create({consents}) {
    return new UserConsentsStatusUserValueObject({consents})
  }

  constructor({consents}) {
    super()

    this.#consents = consents
  }

  get consents() {
    return this.#consents
  }

  set consents(consents) {
    this.#consents = consents
  }

  getConsentStatus({key}) {
    const consent = this.#consents.find(consent => consent.key === key)

    if (consent) return consent.status
  }

  setConsentStatus({key, status}) {
    if (this.#consents.length > 0) {
      this.#consents = this.#consents.map(consent => {
        if (consent.key === key) return UserConsentUserValueObject.create({key, status})
        return consent
      })
      if (this.#consents.every(consent => consent.key !== key)) {
        this.#consents = [...this.#consents, UserConsentUserValueObject.create({key, status})]
      }
    } else {
      this.#consents = [UserConsentUserValueObject.create({key, status})]
    }
  }

  toJSON() {
    return {consents: this.#consents}
  }
}
